import styled from 'styled-components';
// import { COLORS, FONTS } from "Styles/Constants";

import SnackbarContent from '@material-ui/core/SnackbarContent';

/**
 * @constant
 * @description Styled wrapper for SnackbarContent with custom theming.
 * Provides enhanced styling for toast notification content with professional appearance.
 *
 * Features:
 * - **Custom Styling**: Enhanced appearance over default Material-UI styling
 * - **Success Theme**: Red background color for success notifications (Note: appears to be inverted)
 * - **Proper Spacing**: Left padding for content alignment
 * - **Message Styling**: Custom styling for notification message text
 * - **Icon Styling**: Consistent styling for close icons
 * - **Professional Layout**: Clean, readable notification design
 *
 * Styling Details:
 * - **Background Color**: Red background for success state (may need review)
 * - **Padding**: 30px left padding for content spacing
 * - **Message Text**: Black text color with 15px font size
 * - **Max Width**: Calculated width to account for icon space
 * - **Close Icon**: Muted color (#a4afb7) for subtle appearance
 *
 * Note: The success class appears to use red background color, which may be
 * intended for error states. This might need review for proper color coding.
 *
 * @type {StyledComponent}
 *
 * @example
 * // Usage in Toast component
 * <SnackbarContentWrapper
 *   className="themed"
 *   style={{ background: success ? "#3498db" : "#e74c3c" }}
 *   message={<span>{message}</span>}
 * />
 *
 * @example
 * // With success styling
 * <SnackbarContentWrapper className="suceess">
 * Content with red background and styled text
 * </SnackbarContentWrapper>
 *
 * @see SnackbarContent - Material-UI SnackbarContent component
 * @see styled - styled-components library for component styling
 */
export const SnackbarContentWrapper = styled(SnackbarContent)`
    &.suceess {
        background-color: red;
        padding-left: 30px;

        .notification-message {
            color: #000;
            font-size: 15px;
            max-width: calc(100% - 75px);
        }

        .close-icon {
            color: #a4afb7;
        }
    }
`;
